import PropTypes from 'prop-types';

function TableRowColumnDetails({ shipment }) {
  return (
    <>
      {shipment.patient.firstName} {shipment.patient.lastName}
    </>
  );
}

TableRowColumnDetails.propTypes = {
  shipment: PropTypes.object.isRequired,
};

export default TableRowColumnDetails;
